<template>
  <div class="main">
    <toptab></toptab>
    <div class="newwhiteouter">
      <div id="demo" class="carousel slide" data-ride="carousel">
        <!-- 指示符 -->
        <ul class="carousel-indicators" style="bottom:-70px">
          <template v-for="(item,index) in projectbanner">
            <!-- <li data-target="#demo" :data-slide-to="index" class="active" :key="index"></li> -->
            <li data-target="#demo" :data-slide-to="index" :class="index==0? 'active':'' " :key="index"></li>
          </template>
        </ul>

        <!-- 轮播图片 -->
        <div class="carousel-inner">
          <template v-for="(item,index) in projectbanner">
            <div
              class="carousel-item"
              :class="index==0? 'active':'' "
              :key="index"
              :style="'background: #fff url('+item.image+') center center no-repeat;'"
              @click="goDeatil('projectdetail',item.id)"
            >
              <div class="text paddingallllll">
                <div class="textitle animated fadeInUp">
                  <b>{{item.title}}</b>
                </div>
                <div class="textinfo animated fadeInUp">{{item.line}}</div>
                <!-- <div class="textimg animated fadeInUp">
                  <a href="javascript:void(0);">
                    <img src="/static/index/more2.png" />
                  </a>
                </div>-->
              </div>
              <div class="blackcover"></div>
            </div>
          </template>
        </div>
        <!-- 左右切换按钮 -->
        <!-- <a class="carousel-control-prev" href="#demo" data-slide="prev" style="z-index:40">
          <img src="/static/左箭头.png" style="width:60px;height:70px" />
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next" style="z-index:40">
          <img src="/static/右箭头.png" style="width:60px;height:70px" />
        </a>-->
      </div>
    </div>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div class="firstmain">
          <div class="mapimg animated fadeInUp">
            <img :src="firstinfo.thumbnail" alt />
          </div>
          <div class="firstdetail animated fadeInUp">
            <div class="firsttitle animated fadeInUp">
              <b>{{firstinfo.title}}</b>
            </div>
            <div class="firsttime animated fadeInUp martop">发布时间:{{firstinfo.created_at}}</div>
            <div class="firsttime animated fadeInUp">浏览量：{{firstinfo.view}}</div>
          </div>
        </div>
        <div v-html="firstinfo.contents" class="mapinfo animated fadeInUp"></div>
        <!-- <div class="mainimg">
          <img src="../../static/纯色图.jpeg" alt />
        </div>-->
        <div class="maintitle" id="projectdetail">
          <b>其他主营产品</b>
        </div>
        <div class="mainlist" v-if="!isSmall">
          <template v-for="(item,_index) in goodslist">
            <gooditem :key="_index" :project="item"></gooditem>
          </template>
        </div>
        <div class="mainlist" v-if="isSmall">
          <template v-for="(item,_index) in goodslist">
            <gooditemitem :key="_index" :project="item"></gooditemitem>
          </template>
        </div>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import gooditem from "../components/short-project-item";
import gooditemitem from "../components/short-project-item copy";
import footeritem from "../components/footer-item";
export default {
  components: {
    toptab,
    footeritem,
    gooditem,
    gooditemitem
  },
  data() {
    return {
      projectbanner: [],
      goodslist: [],
      firstinfo: "",
      id: "",
      isSmall: false
    }
  },
  mounted() {
    let { id } = this.$route.params
    this.id = id
    this.loadData();
    this.$nextTick(() => {
      require('../../utils/project-detail');
      this.$e.$on("smallWindow", () => {
        console.log(this.isSmall);
        this.isSmall = true
      })
      this.$e.$on("bigWindow", () => {
        console.log(this.isSmall);
        this.isSmall = false
      })
    })
    if (window.first) {
      console.log("llllllllllll");
      window.location.reload()
      window.first = false
    }
  },
  updated() {
    console.log("jjjjjjjjj", this.$route.params);
  },
  methods: {
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.getProduct, { id: this.id })
        .then(res => {
          console.log(res.data);
          let { error_code, product, recommends } = res.data;
          if (error_code == 2001) {
            this.firstinfo = product;
            this.goodslist = recommends
          }
        });
      this.$axios.post(this.$url.getProductBanner, {})
        .then(res => {
          console.log(res.data);
          let { error_code, banners } = res.data;
          if (error_code == 2001) {
            this.projectbanner = banners
          }
        });
    },
  },
  watch: {
    "$route"(n, o) {
      console.log(n, o);
      let { id } = this.$route.params
      this.id = id
      this.loadData();
    }
  }
}
</script>

<style scoped>
@import "../css/padding.css";
@import "../css/animate.min.css";

.main {
  padding-top: 0.67rem;
}

#demo {
  width: 1920px;
  height: 492px;
  margin: 0 auto;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner {
  width: 100%;
  height: 492px;
  /* position: relative; */
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner .carousel-item {
  padding-top: 1rem;
  width: 100%;
  height: 492px;
  background-size: cover;
  /* max-height: 1080px;
  min-height: 8.6rem; */
  position: relative;
}
#demo .carousel-inner .text {
  width: 1440px;
  /* margin: 0 auto; */
  font-size: 40px;
  color: white;
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

#demo .carousel-inner .text .textitle {
}

#demo .carousel-inner .text .textinfo {
}

/* #demo .carousel-inner .text .textimg {
  width: 1.8rem;
  height: 0.46rem;
  margin-top: 1.5rem;
}

#demo .carousel-inner .text .textimg img {
  width: 1.8rem;
  height: 0.46rem;
} */

.blackcover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(49, 50, 51, 0.5);
}

.textitle {
  font-size: 0.6rem;
  margin-bottom: 0.58rem;
  text-align: center;
}
.textinfo {
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.4rem;
}

.newwhiteouter {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  height: 492px;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}

.mainouter {
  width: 100%;
  padding: 1rem 0;
}
.whiteback {
  background-color: #fff;
}
.grayback {
  background-color: #f5f5f5;
}
.firstinfo {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 0.4rem;
}
.maintitle {
  font-size: 0.4rem;
  height: 0.4rem;
  border-left: 4px solid #ff6900;
  line-height: 0.4rem;
  padding-left: 0.1rem;
  margin-bottom: 0.6rem;
  margin-top: 1rem;
}
.firstmain {
  display: flex;
  margin-bottom: 0.6rem;
  /* justify-content: space-between; */
}
.mapimg {
  width: 100%;
  max-width: 24%;
  margin-right: 1rem;
}
.mapimg img {
  width: 100%;
}
.firstinfoinfo {
  width: 55%;
  font-size: 0.2rem;
}

.mapinfo {
  width: 100%;
  font-size: 0.2rem;
  margin-bottom: 0.4rem;
}

.bodythree {
  width: 100%;
  height: 3.14rem;
  background: #fff url(../../static/aboutmid.png) center center no-repeat;
  background-size: cover;
}

.threelist {
  width: 1440px;
  height: 3.14rem;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: 0 auto;
}
.threeitem {
  width: 1.7rem;
  text-align: center;
  height: 1.1rem;
  margin: auto 0;
  color: white;
}
.threetitle {
  font-size: 0.5rem;
  height: 0.5rem;
  margin-bottom: 0.3rem;
}
.threeinfo {
  font-size: 0.2rem;
}
.threeinfotwo {
  font-size: 0.15rem;
}

.mainlist {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.firstdetail {
  margin-left: 0.4rem;
}
.firsttitle {
  font-size: 0.3rem;
  line-height: 1.2rem;
}
.firsttime {
  font-size: 0.14rem;
  line-height: 0.4rem;
}
.mainimg {
  width: 100%;
  margin-bottom: 0.4rem;
}
.mainimg img {
  width: 100%;
}
@media (max-width: 1440px) {
  .threelist {
    width: 100%;
  }
  #demo .carousel-inner .text {
    width: 100%;
  }
}

@media (max-width: 1920px) {
  #demo {
    width: 100%;
  }

  #topdemo {
    width: 100%;
  }
  .firstinfo {
    width: 100%;
  }
}
@media (max-width: 992px) {
  .main {
    padding-top: 100px;
  }
  .mapimg {
    width: 100%;
    max-width: 46%;
    margin-right: 4%;
  }
  .mapimg img {
    width: 100%;
  }

  .firsttitle {
    font-size: 40px;
    line-height: 60px;
  }
  .firsttime {
    font-size: 26px;
    line-height: 40px;
  }
  .martop {
    margin-top: 40px;
  }
  .mapinfo {
    font-size: 30px;
  }

  .maintitle {
    font-size: 60px;
    line-height: 60px;
    height: 60px;
  }

  .mainlist {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .textinfo {
    font-size: 0.4rem;
  }
}

@media (max-width: 1300px) {
  #demo .carousel-inner .carousel-item {
    padding-top: 1.3rem;
  }
}
/* 动画库 */
[class*="animation-"] {
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}

.animation-scale-up {
  animation-name: scale-up;
}

@keyframes scale-up {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/project-detail.vue